import {useNavigate, useSearchParams} from "react-router-dom";
import {containerSelector, useGetContainerQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {ContainerProfile} from "../../components/profile/ContainerProfile/ContainerProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";

type Props = {
  id?: string;
}

export const ContainerProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.container", "Container") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <ContainerProfilePage id={id}/>;
};

export const ContainerProfilePage = (props: Props) => {
  const {id} = props;

  const selectContainer = useMemo(() => {
    return containerSelector()
  }, []);

  const {container, isFetching} = useGetContainerQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      container: selectContainer(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage entity={container} isLoading={isFetching} permissions={["view", "container_view"]}>
      {(entity) => (
        <ContainerProfile container={entity}/>
      )}
    </EntityProfilePage>
  )
};
